import { ContentDisplay } from '../../cdl-react-components/components'
import Link from '../Link'
import { getArticleFeatureImage } from '../../../utilities'

const articleDisplay = (props) => {
    const { article, embedded } = props

    const url = (embedded ? window.location.origin : '') + '/article/' + article.id

    return article ? (
        <Link 
            className="article-display"
            href={url}
            title={article.title} >
            <ContentDisplay content={{
                title: article.title,
                subtitle: article.subtitle,
                image: getArticleFeatureImage(article),
                authors: article.authors.map(x => x.name),
                publicationDate: article.publication_date,
                body: article.synopsis
            }} />
        </Link>
    ) : null
}

export default articleDisplay
